import React from 'react';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Grid } from '@mantine/core';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
import { OwnerSharesSection } from 'src/financial/financial-data/financial-item/forms/common/OwnerSharesSection';
import { useFlags } from 'src/feature-flags/FlagsHook';
import styles from 'src/financial/financial-data/financial-item/forms/common/FormLayout.module.css';
import { ValuationAccordionItem } from 'src/financial/financial-data/financial-item/rework/ValuationAccordionItem';
import { VALUATION_SECTION } from 'src/financial/financial-data/financial-item/rework/financialItemRework';

const LOAN = 'Loan';

export function Loan(props: ProductFormComponentProps) {
  const { flagEnabledFinancialItemOwners, flagEnabledFinancialRework } = useFlags();
  return (
    <GenericFinancialItemFormWrapper
      title={'Liabilities > Loan'}
      {...props}
      product={LOAN}
      defaultJointOwner
    >
      <FormAccordion defaultValue={[VALUATION_SECTION, 'summary', 'amount', 'interest', 'term']}>
        <ValuationAccordionItem product={LOAN} />
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<FinancialFormField field="type" product={LOAN} />}
              second={<FinancialFormField field="description" product={LOAN} />}
            />
            <GridPair
              first={<FinancialFormField field="provider" product={LOAN} />}
              second={<FinancialFormField field="provider_reference_number" product={LOAN} />}
            />
            {flagEnabledFinancialItemOwners && !flagEnabledFinancialRework && (
              <GridPair
                fullWidth
                first={<OwnerSharesSection product={LOAN} valueField="remaining_balance" />}
              />
            )}
          </Grid>
        </FormAccordionItem>
        <FormAccordionItem value="amount" label="Loan amount and repayment information">
          <Grid>
            <GridPair first={<FinancialFormField field="initial_amount" product={LOAN} />} />
            <GridPair
              isHighlighted
              hide={flagEnabledFinancialRework}
              first={<FinancialFormField field="remaining_balance" product={LOAN} />}
              second={<FinancialFormField field="remaining_balance_date" product={LOAN} />}
            />

            <Grid.Col span={12}>
              <Grid className={styles.highlightedGrid}>
                <GridPair
                  first={<FinancialFormField field="repayment_amount" product={LOAN} />}
                  second={<FinancialFormField field="repayment_frequency" product={LOAN} />}
                />
              </Grid>
            </Grid.Col>
          </Grid>
        </FormAccordionItem>
        <FormAccordionItem value="interest" label="Interest rate details">
          <Grid className={styles.highlightedGrid}>
            <GridPair
              first={<FinancialFormField field="interest_rate_type" product={LOAN} />}
              second={<FinancialFormField field="interest_rate" product={LOAN} />}
            />
          </Grid>
        </FormAccordionItem>
        <FormAccordionItem value="term" label="Term">
          <Grid className={styles.highlightedGrid}>
            <GridPair
              first={<FinancialFormField field="term_start_date" product={LOAN} />}
              second={<FinancialFormField field="term_end_date" product={LOAN} />}
            />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}
